import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
// Figmaから3倍で書き出した画像(269x321)の論理サイズ。
// 時計イラストがカード枠(69.5x76)からはみ出して描かれるため、カードより一回り大きい
const BADGE_WIDTH = 269 / 3;
const BADGE_HEIGHT = 321 / 3;
export const HomeCountLessonBadge = ({ onClick, classObject }) => (React.createElement("img", { className: css(styles.badge, classObject), src: "/assets/images/count_lesson/home_count_lesson_badge.png", alt: "\u30AB\u30A6\u30F3\u30C8\u30EC\u30C3\u30B9\u30F3", onClick: onClick }));
const styles = StyleSheet.create({
    badge: {
        display: 'block',
        width: BADGE_WIDTH,
        height: BADGE_HEIGHT,
        cursor: 'pointer',
    },
});
